var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "enterprise-wechat-approval-detail" }, [
    _c(
      "div",
      {
        staticClass: "section",
        staticStyle: { "margin-bottom": "10px", "min-width": "1200px" }
      },
      [
        _c(
          "el-form",
          { attrs: { inline: "", "label-width": "100px" } },
          [
            _c(
              "el-form-item",
              {
                attrs: { label: _vm.$t("CargoMsg.Cargo_ApprovalSerialNumber") }
              },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: _vm.$t("CargoMsg.Cargo_ApprovalSerialNumber"),
                    clearable: ""
                  },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleSearch($event)
                    }
                  },
                  model: {
                    value: _vm.filter.documentProcessNo,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "documentProcessNo", $$v)
                    },
                    expression: "filter.documentProcessNo"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleSearch }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " ")]
                ),
                _c("el-button", { on: { click: _vm.handleReset } }, [
                  _vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Reset")) + " ")
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "section", staticStyle: { flex: "1", padding: "0" } },
      [
        _c("cargo-ag-grid", {
          ref: "enterpriseWechatGrid",
          staticStyle: { "min-width": "1200px" },
          attrs: {
            "show-side-bar": false,
            "column-defs": _vm.columnDefs,
            "grid-options": _vm.gridOptions,
            "grid-params": _vm.gridParams,
            "auto-fit-content": false,
            "row-data": _vm.rowData
          },
          on: {
            "update:gridParams": function($event) {
              _vm.gridParams = $event
            },
            "update:grid-params": function($event) {
              _vm.gridParams = $event
            }
          }
        }),
        _c("cargo-pagination", {
          attrs: {
            total: _vm.filter.total,
            page: _vm.filter.pageNum,
            limit: _vm.filter.pageSize
          },
          on: {
            "update:page": function($event) {
              return _vm.$set(_vm.filter, "pageNum", $event)
            },
            "update:limit": function($event) {
              return _vm.$set(_vm.filter, "pageSize", $event)
            },
            pagination: _vm.toQuery
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }